import { css, cva } from "styled-system/css";

export { pageContainerStyles as pageStyles, pageHeaderStyles as headerStyles } from "#/app.css";
export {
  filterInputContainerStyles,
  filterInputStyles,
  filterInputIconStyles as filterSearchIconStyles,
} from "#/app.css";

export const titleStyles = css({
  fontFamily: "sans",
  fontWeight: "900",
  letterSpacing: "-0.025em",
  color: "textBase",
  fontSize: "h2",
});

export const gridStyles = css({
  display: "grid",
  gridTemplateColumns: {
    base: "repeat(3, 1fr)",
    sm: "repeat(4, 1fr)",
    lg: "repeat(5, 1fr)",
    xl: "repeat(6, 1fr)",
  },
  gap: {
    base: "sm",
    md: "xl",
  },
});

export const loadingStyles = css({
  paddingY: "xxl",
  textAlign: "center",
  fontWeight: "700",
  color: "color-mix(in srgb, {colors.textBase}, transparent 60%)",
});

export const emptyStyles = css({
  gridColumn: "1 / -1",
  paddingY: "xxl",
  textAlign: "center",
  fontWeight: "700",
  color: "color-mix(in srgb, {colors.textBase}, transparent 60%)",
});

export const filterContainerStyles = css({
  marginBottom: "0.75rem",
});

export const filterInnerStyles = css({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "sm",
  flexWrap: "wrap",
});

export const selectContainerStyles = css({
  position: "relative",
  minWidth: {
    base: "auto",
    md: "200px",
  },
});

export const selectStyles = css({
  width: "100%",
  padding: "sm",
  borderRadius: "medium",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "bgBase300",
  backgroundColor: "bgBase100",
  color: "textBase",
  cursor: "pointer",
  outline: "none",
});

export const filterButtonStyles = css({
  cursor: "pointer",
  transitionProperty: "all",
  transitionDuration: "200ms",
  userSelect: "none",
  border: "none",
  outline: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "sm",
  width: "2rem",
  height: "2rem",
  borderRadius: "full",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "bgBase300",
  backgroundColor: "transparent",
  color: "textBase",
  _hover: {
    backgroundColor: "color-mix(in srgb, {colors.textBase}, transparent 95%)",
  },
});

export const filterButtonLabelStyles = css({
  display: "none",
});

export const dropdownStyles = css({
  position: "absolute",
  top: "100%",
  right: 0,
  marginTop: "sm",
  zIndex: 50,
  backgroundColor: "bgBase100",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "bgBase300",
  borderRadius: "medium",
  boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1)",
  minWidth: "200px",
  maxWidth: "calc(100vw - 2rem)",
  maxHeight: "300px",
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
});

export const dropdownItemStyles = cva({
  base: {
    cursor: "pointer",
    transitionProperty: "all",
    transitionDuration: "200ms",
    userSelect: "none",
    border: "none",
    outline: "none",
    paddingInline: "md",
    paddingY: "sm",
    textAlign: "left",
    fontSize: "sm",
    backgroundColor: "transparent",
    color: "textBase",
    _hover: {
      backgroundColor: "bgBase200",
    },
  },
  variants: {
    active: {
      true: {
        backgroundColor: "color-mix(in srgb, {colors.primary}, transparent 90%)",
        color: "primary",
        fontWeight: "600",
      },
    },
  },
});
